import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { TermConditionsComponent } from '../modal/term-conditions/term-conditions.component';
import { AuthService } from '../../../service/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-success-register',
  templateUrl: './success-register.component.html',
  styleUrls: ['./success-register.component.scss'],
})
export class SuccessRegisterComponent {
  @ViewChild('select') select: MatSelect;
  @ViewChild('deleteSwal')
  public readonly deleteSwal!: SwalComponent;
  allSelected: boolean = false;
  validateRut: boolean = false;
  validateRutCompany: boolean = false;
  showInput: boolean = false;
  showForm: boolean = false;
  showRegister: number = 0;
  userRut: any;
  preferences: any[] = [
    { value: 'Factoring', viewValue: 'Factoring' },
    { value: 'Garantías', viewValue: 'Garantías' },
    { value: 'creditos', viewValue: 'Creditos' },
  ];

  constructor( private router: Router, public dialog: MatDialog, private auth: AuthService) {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation!.extras.state as {
      transd: number;
      form?: any;
    };
    this.showRegister = state.transd;
    this.userRut = state.form.userRut;
    console.log(state.form.userRut);
  }

  ngOnInit(): void {
  }

  form = new FormGroup({
    preference: new FormControl('', [Validators.required]),

  });

  get f() {
    return this.form.controls;
  }

  toggleAllSelection() {
    if (this.allSelected) {
      this.select.options.forEach((item: MatOption) => item.select());
    } else {
      this.select.options.forEach((item: MatOption) => item.deselect());
    }
  }

  optionClick() {
    let newStatus = true;
    this.select.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.allSelected = newStatus;
  }

  openHeaderDialog() {
    const dialogRef = this.dialog.open(TermConditionsComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  submit(form: any) {
    const cleanedCompanyRut = this.userRut
    .replace(/[^\d-]/g, '')
    .replace(/[^\d.]/g, '');
    this.userRut = parseInt(
      cleanedCompanyRut.substring(0, cleanedCompanyRut.length - 1)
    );
    console.log(this.userRut)
    
    form.preference = form.preference.toString();
    Swal.fire({
      text: 'Se estan enviando tu registro',
      icon: 'question',
      didOpen: () => {
        Swal.showLoading();
        this.auth.registerPreferences(this.userRut, form.preference).subscribe({
          next: (res) => {
            Swal.update({
              icon: 'success',
              text: ' Registro enviado con exito',
            });
            this.router.navigate(['/register']),
              {
                skipLocationChange: true,
                replaceUrl: false,
                queryParams: { id: this.userRut },
              };
            this.showForm = true;
            Swal.hideLoading();
            setTimeout(() => {
              Swal.close();
            }, 2000);
          },
          error: (err) => {
            Swal.fire({
              title: 'Error',
              text: '¡Hubo Error',
              icon: 'error',
              timerProgressBar: true,
            });
            console.log('Error', err);
          },
        });
      },
    });
  }
}